import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
const buyers = [{
  name: 'Valentina R.',
  location: 'México'
}, {
  name: 'Camila G.',
  location: 'Colombia'
}, {
  name: 'Lucía F.',
  location: 'Argentina'
}, {
  name: 'Fernanda S.',
  location: 'Chile'
}, {
  name: 'Andrea P.',
  location: 'Perú'
}, {
  name: 'Gabriela M.',
  location: 'Ecuador'
}, {
  name: 'Mariana T.',
  location: 'Uruguay'
}, {
  name: 'Daniela C.',
  location: 'Costa Rica'
}, {
  name: 'Paola H.',
  location: 'Guatemala'
}, {
  name: 'Carolina D.',
  location: 'República Dominicana'
}, {
  name: 'Natalia V.',
  location: 'Bolivia'
}, {
  name: 'Alejandra B.',
  location: 'Paraguay'
}];
export function FloatingNotification() {
  const [visible, setVisible] = useState(false);
  const [buyer, setBuyer] = useState(buyers[0]);
  useEffect(() => {
    const initial = window.setTimeout(() => setVisible(true), 5000);
    const cycle = window.setInterval(() => {
      setVisible(false);
      window.setTimeout(() => {
        setBuyer(buyers[Math.floor(Math.random() * buyers.length)]);
        setVisible(true);
      }, 850);
    }, 30000);
    return () => {
      window.clearTimeout(initial);
      window.clearInterval(cycle);
    };
  }, []);
  return <AnimatePresence data-id="element-74" data-mp="1mx3xhase4ohr">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 35,
      x: -12
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 15,
      scale: 0.96
    }} transition={{
      type: 'spring',
      stiffness: 380,
      damping: 26
    }} className="fixed bottom-4 left-4 z-50 max-w-sm md:bottom-8 md:left-8" data-id="element-75" data-mp="1mvsrr5fdx6o0">
          <div className="flex items-start gap-3 rounded-2xl border border-brand-gold/40 bg-white p-4 shadow-xl" data-id="element-76" data-mp="138v4iyj0weh7">
            <div className="mt-0.5 rounded-full bg-brand-purple/10 p-2" data-id="element-77" data-mp="z5q3l0elckuo">
              <CheckCircle2Icon className="h-5 w-5 text-brand-purple" data-id="element-78" data-mp="u7wx069dlotv" />
            </div>
            <div data-id="element-79" data-mp="kk2m5mzrvufi">
              <p className="mb-1 text-xs text-brand-muted" data-id="element-80" data-mp="kjj9akozbw8c">🔔 Compra verificada · hace unos minutos</p>
              <p className="text-sm font-medium text-brand-text" data-id="element-81" data-mp="olwgldjdk278">
                <strong data-id="element-82" data-mp="alv4f1xnt8cg">{buyer.name}</strong> de {buyer.location} compró
              </p>
              <p className="text-sm font-bold text-brand-purple" data-id="element-83" data-mp="ao7w46t7yx2p">Mega Pack Maestro de Gemoterapia</p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}